<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="px-3 board-header">
      <div class="col-12" style="padding: 0px 10px;">
        <h4>{{ this.$t('reports.cxiSalesReport.reportHeader1') }}</h4>
        {{ this.$t('reports.cxiSalesReport.reportHeader2') }}
      </div>
      <div v-if="this.myIh1 !== '0'" class="row px-3 board-header">
        <div class="col-12" style="padding: 0px 10px;">
          <span>Nacional:</span>
          <span class="idx-bold">
            {{ nationalData }}
          </span>
          <span>Regional - {{ groupName }}: </span>
          <span class="idx-bold">
            {{ groupData }}
          </span>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4" style="padding: 0px 10px;">
          <div class="col-12 board-border">
            <div class="col-12" style="display: flex;">
              <div style="min-width: 100%;">
                <div class="nps-display">
                  <div class="idx-card-title">
                    {{ this.$t('reports.cxiSalesReport.reportTitle') }}
                  </div>
                  <div class="nps-chart">
                    <radial-progress-bar
                      v-if="cxiScore !== null && cxiScore !== undefined"
                      :diameter="240"
                      :stroke-width="20"
                      innerStrokeColor="#f1f1f1"
                      :startColor="colorBalance"
                      :stopColor="colorBalance"
                      :completed-steps="
                        completedSteps ? parseFloat(completedSteps) : 0
                      "
                      :total-steps="totalSteps"
                    >
                      <b
                        id="number-cxi"
                        :style="{
                          color: colorBalance,
                          fontSize: '2.8em',
                          fontWeight: 'bold',
                        }"
                        >{{ completedSteps }}</b
                      >
                      <b-tooltip
                        v-if="cxiScore !== null && cxiScore !== undefined"
                        target="number-cxi"
                        placement="bottom"
                      >
                        {{ this.$t('reports.cxiSalesReport.cxiLabel') }}
                        <strong>{{ cxiScore }}</strong>
                      </b-tooltip>
                    </radial-progress-bar>
                    <div v-else>
                      {{ this.$t('reports.cxiSalesReport.noDataMsg') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8" style="padding: 0px 10px;">
          <div class="col-12 board-border" style="padding: 0px 10px;">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
        <div class="col-12" style="padding: 0px 10px;">
          <div class="col-12 board-border" style="padding: 0px 10px;">
            <b-table
              :fields="fields"
              :items="items"
              caption-bottom
              sort-icon-left
            >
              <template v-slot:cell(question)="row">
                <div style="max-width: 85%;">
                  {{ row.item.question }}
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import loader from '@/components/atoms/loader';
import api from '../../../../services/api';

export default {
  name: 'cxiSalesReport',
  components: {
    RadialProgressBar,
    animatedNumber,
    loader,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    chartOptions: {},
    cxi: {},
    cxiScore: 0,
    completedSteps: null,
    totalSteps: 100,
    colorBalance: '#fff',
    fields: [],
    items: [],
    nationalData: null,
    groupData: null,
    groupname: null,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getCxiData();
    },

    myActionId: function watchmyActionId() {
      this.getCxiData();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getCxiData();
    },

    calendarDates: function watchCalendarDates() {
      this.getCxiData();
    },

    myIh1: function watchMyIh1() {
      this.getCxiData();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getCxiData();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getCxiData();
    },

    myIh2: function watchMyIh2() {
      this.getCxiData();
    },

    myMetric: function watchMyMetric() {
      this.getCxiData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getCxiData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getCxiData();
    },
  },

  methods: {
    async renderChart(data) {
      this.chartOptions = {
        title: {
          align: 'left',
          text: this.$t('reports.cxiSalesReport.cxiLabel'),
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
            width: '100%',
          },
        },
        xAxis: {
          categories: data.categories,
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 100,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: this.$t('reports.cxiSalesReport.cxiLabel'),
            data: data.series,
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595'],
      };
    },

    async chartEmpty() {
      if (this.cxi.categories.length === 0) {
        this.chartOptions = {
          title: {
            align: 'left',
            text: this.$t('reports.cxiSalesReport.reportTitle'),
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: this.type,
            borderColor: 'rgba(0, 0, 0, 0.09)',
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
        };
      }
    },

    async getCxiData() {
      this.loading = true;

      const response = await api.get('/reports/cxi-latina', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          reportType: 'sale',
        },
      });

      if (response) {
        this.cxi.categories = response.data.categories;
        this.cxi.series = response.data.series;
        this.cxiScore = response.data.score;
        this.completedSteps = this.cxiScore;
        this.items[0].score = response.data.satScore;
        this.items[1].score = response.data.recScore;
        this.items[2].score = response.data.revScore;
        this.setColorCxi(this.completedSteps);
        this.renderChart({
            categories: this.cxi.categories,
            series: this.cxi.series,
        });
        this.nationalData = response.data.cxiNacional;
        this.groupData = response.data.cxiRegional;
        this.groupname = response.data.regionalName;
      }

      this.loading = false;
    },
    setColorCxi(percentBalace) {
      if (percentBalace >= 80) {
        this.colorBalance = '#6bca6c';
      } else if (percentBalace < 80 && percentBalace >= 70) {
        this.colorBalance = '#9fd77a';
      } else if (percentBalace < 70 && percentBalace >= 50) {
        this.colorBalance = '#fbcf3f';
      } else if (percentBalace < 50 && percentBalace >= 20) {
        this.colorBalance = '#fa834f';
      } else if (percentBalace < 20) {
        this.colorBalance = 'red';
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.cxiSalesReport.questionHeader'),
        sortable: true,
        class: 'questionTh',
      },
      {
        key: 'score',
        label: this.$t('reports.cxiSalesReport.score'),
        sortable: true,
        class: 'scoreTh',
      },
    ];
    this.items = [
      {
        question: '¿Qué tan satisfecho está con el proceso de compra?',
        score: 0,
      },
      {
        question: 'En una escala de 0 a 10, cuanto usted recomendaría a este concesionario para un amigo o familiar?',
        score: 0,
      },
      {
        question: '¿Qué probabilidad hay de que compre un nuevo vehículo en este concessionario?',
        score: 0,
      },
    ];
  },

  async mounted() {
    this.loading = true;
    await this.getCxiData();
    this.loading = false;
  },
};
</script>

<style lang="scss">
#number-cxi {
  font-size: 50px !important;
}
.scoreTh {
  width: 70px;
  padding-right: 0px !important;
}

.questionTh {
  width: calc(100% - 200px);
}
</style>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.board-box {
  width: 10%;
  text-align: left;
  font-size: 16px;
  margin: 0px 20px;
  border: 1px solid #eee;
}
.board-box-value {
  float: right;
  padding-right: 40%;
  font-size: 24px;
}
.nps-display {
  border: none !important;
}
.board-percentil {
  padding: 20px 0px 20px 20px;
  min-width: 150px;
}
.board-percentil-label {
  font-size: 14px;
}
.board-percentil-percent {
  font-size: 20px;
}
.board-percentil-value {
  font-size: 16px;
}
.board-border {
  border: 1px solid #eee;
}
.board-header h1 {
  font-size: 16px;
}
.radial-progress-inner {
  justify-content: center;
  font-size: 3.2em;
  cursor: pointer;
}
.nps-display {
  border: 1px solid $gray-light;
  padding: 18px 0;
  flex-direction: column;
  border-radius: 4px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }
  .nps-chart {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
  }
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/cxi-sales-report/index.vue